"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRepositories = exports.useReindex = void 0;
const index_1 = require("../../../index");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const react_1 = require("react");
const admin_context_1 = require("../admin-context");
const react_intl_1 = require("react-intl");
/**
 *  POST request to reindex given stores.
 */
function reindexCall(url, names) {
    return index_1.abortableFetch(url, {
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
        method: 'POST',
        body: JSON.stringify(names),
    });
}
exports.useReindex = () => {
    const intl = react_intl_1.useIntl();
    const { reindexUrl } = react_1.useContext(admin_context_1.AdminContext);
    const { showSnackbar } = react_1.useContext(index_1.SnackbarContext);
    const [loading, setLoading] = react_1.useState(false);
    const reindex = event_callback_hook_1.useEventCallback(async (repositories) => {
        const names = repositories
            .filter((repository) => repository.active)
            .map((r) => r.name);
        try {
            setLoading(true);
            await reindexCall(reindexUrl, names).none();
            const message = intl.formatMessage({
                id: 'EAS_DEVTOOLS_REINDEX_MSG_SUCCESS',
                defaultMessage: 'Reindexace dokončena',
            });
            showSnackbar(message, index_1.SnackbarVariant.SUCCESS);
            setLoading(false);
        }
        catch (err) {
            setLoading(false);
            if (err.name !== 'AbortError') {
                const errorDetail = index_1.getErrorMessage(err);
                const message = intl.formatMessage({
                    id: 'EAS_DEVTOOLS_REINDEX_MSG_ERROR',
                    defaultMessage: 'Chyba reindexace: {detail}',
                }, { detail: errorDetail });
                showSnackbar(message, index_1.SnackbarVariant.ERROR);
                throw err;
            }
        }
    });
    return {
        loading,
        reindex,
    };
};
/**
 * GET request to get all stores.
 */
function getRepositories(url) {
    return index_1.abortableFetch(url, {
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
        method: 'GET',
    });
}
exports.useRepositories = () => {
    const { reindexUrl } = react_1.useContext(admin_context_1.AdminContext);
    const [repositories, setRepositories] = react_1.useState([]);
    react_1.useEffect(() => {
        getRepositories(reindexUrl)
            .json()
            .then((repositiories) => {
            setRepositories(repositiories.map((repository) => ({
                name: repository,
                active: false,
            })));
        });
    }, [reindexUrl]);
    return [repositories, setRepositories];
};
//# sourceMappingURL=admin-reindex-hooks.js.map